import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/Home';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Footer from './components/Footer';
import CookiesBanner from './components/CookiesBanner';
import PoliticaCookies from './pages/PoliticaCookies'
import AvisoPrivacidad from './pages/AvisoPrivacidad';
import TerminosCondiciones from './pages/TerminosCondiciones';

function App() {
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/politica-cookies" element={<PoliticaCookies />} />
        <Route path="/aviso-privacidad" element={<AvisoPrivacidad />} />
        <Route path="/terminos-condiciones" element={<TerminosCondiciones />} />
      </Routes>
      <Footer />
      <CookiesBanner />
    </>
  );
}

export default App;
